module.exports = __webpack_public_path__ + "img/emoji_52.6ebbe7f4.png";